export default "__VITE_ASSET__9fd9e410__"